import ShPopConfirm from '@/components/Helpers/ShPopConfirm';
import ShIconWithDescription from '@/components/Helpers/ShIconWithDescription';
import moment from 'moment';
// @vue/component
export default {
  name: 'SmsQueueItem',

  components: {
    ShPopConfirm,
    ShIconWithDescription,
  },

  props: {
    contentSize: {
      type: String,
      default: 'smallTable',
  },
  statusList: {
    type: Array,
    default: () => [],
  },
  typeList: {
    type: Array,
    default: () => [],
  },
  item: {
    type: Object,
    default: () => ({}),
  }
},

  data() {
    return {

    };
  },

  computed: {
    smsStatus() {
      return this.statusList.find(item => item.status === this.item.status);
    },
    smsType() {
      return this.typeList.find(item => item.typ === this.item.type);
    },
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'sms/removeSmsFromQueue'
      ]);
    },
    isSmsPlannedForLater() {
      return moment(this.item.stamp).isAfter()
    }
  },

  watch: {

  },

  methods: {
    async handleRemoveSmsFromQueue() {
      const responseStatus = await this.$store.dispatch('sms/removeSmsFromQueue', { uuid_sms: this.item.uuid_sms });
      if (responseStatus === 200) {
        this.$store.commit('sms/REMOVE_FROM_QUEUE', this.item);
        this.$message({
          type: 'success',
          message: 'Sms został usunięty z kolejki.',
        });
      } else {
        this.$message({
          type: 'error',
          message: "Wystąpił błąd podczas usuwania SMS'a",
        });
      }
    },
  }
}
